import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const SearchSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default SearchSVG;
